export const siteConfig = {
  appName: 'Inshore Scaffolding & Plant Hire',
  shortName: 'Inshore',
  packageName: 'inshore-scaffolding-and-plant-hire',
  tagline: 'Scaffolding & plant hire · Factoria',
  menuTagline: 'West Rand hire yard',
  description:
    'Scaffolding rental and plant hire from 2 Barratt Road, Factoria, Krugersdorp. Call the yard for West Rand scaffolding, machinery, and site tools.',
  footerDescription:
    'Scaffolding rental and plant hire from the Factoria yard on Barratt Road. Serving Krugersdorp and the West Rand.',
  phoneDisplay: '082 337 5061',
  phoneTel: '+27823375061',
  phoneHref: 'tel:+27823375061',
  whatsappHref: 'https://wa.me/27823375061',
  addressLines: ['2 Barratt Rd', 'Factoria', 'Krugersdorp, 1739'],
  addressLocality: 'Krugersdorp',
  addressRegion: 'Gauteng',
  postalCode: '1739',
  country: 'ZA',
  streetAddress: '2 Barratt Rd, Factoria',
  geo: {
    latitude: -26.1196495,
    longitude: 27.816944,
  },
  mapsUrl:
    'https://www.google.com/maps/place/Inshore+Scaffolding+%26+Plant+Hire/@-26.1196495,27.816944,17z',
  mapsDirectionsUrl:
    'https://www.google.com/maps/dir/?api=1&destination=-26.1196495,27.816944',
  areaServed: ['Factoria', 'Krugersdorp', 'West Rand', 'Gauteng'],
  ratingValue: '4.6',
  reviewCount: '28',
  priceRange: '$$',
  hoursNote: 'Maps lists opening around 07:15 — confirm hours when you call.',
  hoursPlaceholder: true,
  siteUrl: 'https://inshore-scaffolding-and-plant-hire.pages.dev',
  ogImage: 'https://inshore-scaffolding-and-plant-hire.pages.dev/og-image.png',
} as const;

export type SiteConfig = typeof siteConfig;
